"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// for FE to use
exports.default = {
    ONGOING: 'Ongoing',
    UPCOMING: 'Upcoming',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    NO_SHOW: 'No-show',
};
